import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { AuthProvider } from '../components/AuthProvider';
import { COLORS } from '../utils/Colors';
import { AsideMenu } from '../components/menu/AsideMenu';
import screenImage from '../../assets/images/welcome-pattern.png';
import { ProfileWidget } from '../components/ProfileWidget';
import { WidgetType } from '../components/AsideWidgets';

const Root = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    background: ${COLORS.DULL}
`;

const Main = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    
    @media screen and (max-width: 768px) {
        padding: 60px 10px 10px 10px;
    }
    
    @media screen and (max-width: 480px) {
        padding: 50px 8px 8px 8px;
    }
`;

const BackgroundImage = styled.img`
    height: 60%;
    position: fixed;
    bottom: 5px;
    right: 0;
    z-index: -1;

    @media screen and (max-width: 800px) {
        height: 50%;
        bottom: 10px;
    }
    
    @media screen and (max-width: 480px) {
        height: 40%;
        bottom: 15px;
        right: -20px;
    }
`;

const MobileMenuButton = styled.button`
    display: none;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
    background: white;
    border: none;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    font-size: 16px;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    
    @media screen and (max-width: 768px) {
        display: flex;
    }
`;

const MobileMenuOverlay = styled.div<{ isOpen: boolean }>`
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
    
    @media screen and (max-width: 768px) {
        display: ${props => props.isOpen ? 'block' : 'none'};
    }
`;

interface Props {
  children?: ReactNode;
  selectedTab?: WidgetType;
}

export const MainLayout: FC<Props> = ({
  children,
  selectedTab,
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <AuthProvider>
      <Root>
        <MobileMenuButton onClick={toggleMobileMenu}>
          ☰
        </MobileMenuButton>
        <MobileMenuOverlay isOpen={isMobileMenuOpen} onClick={closeMobileMenu} />
        <AsideMenu selectedTab={selectedTab} isMobileMenuOpen={isMobileMenuOpen} onCloseMobileMenu={closeMobileMenu} />
        <Main>
          <BackgroundImage src={screenImage} alt="background" />
          <ProfileWidget />
          {children}
        </Main>
      </Root>
    </AuthProvider>
  );
};
